import styled from "styled-components";

export const TagAtualizadoContainer = styled.span`
  font-size: var(--font-size-scale-base);
  font-weight: var(--font-weight-medium);
  height: 20px;
`;
